import { http } from "Utils/http";
import { httpDownload } from "Utils/httpDownload";
import { STATUSES } from "Utils/constants";

// get what's new data for the home page
const whatsNew = async () => {

  let status = STATUSES.SUCCESS;
  let body = {}

  const url = "/api/event/whatsnew";
  const res = await http.post(url, body, {})
    .then((res) => {
      return Promise.resolve({ status: status, data: res });
    }).catch(function (error) {
      status = STATUSES.ERROR;;
      return Promise.reject({ status: status, data: error });
    });

  return res;
};

export { whatsNew };